<template>
  <div class="content">
    <slot />
  </div>
</template>

<style scoped>
.content {
  padding-left: 6rem;
  flex: 1;
}
</style>
